import React from "react";
import { Button } from "antd";
import styles from "./DashBoardCard.module.css";
import { SettingsButton } from "../../../icons/SettingsButton";
import { DownloadButton } from "../../../icons/DownloadButton";
import { CloseButton } from "../../../icons/CloseButton";

const CardActions = ({ widget, isSuccess, removeWidget, exportToPNG, showFilters }) => {
    if (widget.gridData.without_header) {
        return <>
            <div style={{ display: "flex", justifyContent: "end", flexDirection: "row-reverse", columnGap: "5px", width: `30%` }}>
                <Button
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                    onMouseDown={e => e.stopPropagation()}
                    onClick={(e) => {
                        removeWidget(e);
                    }}
                    icon={
                        <CloseButton />
                    }
                    type="link"
                    data-testid="closeWidget"
                >
                </Button>
                {widget?.gridData?.showFilter && isSuccess && (
                    <div style={{ display: "flex", columnGap: "5px" }}>
                        <Button
                            style={{
                                position: "inherit",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: " 10px",
                            }}
                            onMouseDown={e => e.stopPropagation()}
                            className={styles.filtersBtn}
                            icon={<SettingsButton />}
                            onClick={showFilters}
                            data-testid="openFilters"
                        ></Button>
                        <Button
                            style={{
                                position: "inherit",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center", marginRight: "8px",
                            }}
                            onMouseDown={e =>
                                e.stopPropagation()}
                            onClick={exportToPNG}
                            icon={<DownloadButton />}>
                        </Button>
                    </div>

                )}

            </div>
        </>;
    }
    return (
        <div style={{ display: "flex", justifyContent: "end", flexDirection: "row-reverse", columnGap: "5px", width: `30%` }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                    onMouseDown={e => e.stopPropagation()}
                    onClick={(e) => {
                        removeWidget(e);
                    }}
                    icon={
                        <CloseButton />
                    }
                    type="link"
                    data-testid="closeWidget"
                >
                </Button>
            </div>

            <div style={{ display: "flex", columnGap: "5px" }}>
                {widget?.gridData?.showFilter && isSuccess && (
                    <Button
                        style={{
                            position: "inherit",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: " 10px",
                        }}
                        onMouseDown={e => e.stopPropagation()}
                        className={styles.filtersBtn}
                        icon={<SettingsButton />}
                        onClick={showFilters}
                        data-testid="openFilters"
                    ></Button>
                )}
                <Button
                    style={{
                        position: "inherit",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center", marginRight: "8px",
                    }}
                    onMouseDown={e =>
                        e.stopPropagation()}
                    onClick={exportToPNG}
                    icon={<DownloadButton />}>
                </Button>
            </div>
        </div>
    );
};

export default CardActions;